import { format } from '@/utils/time.js';

export default (d, fmt, tz, locale) => format(d, fmt || 'relative', tz, locale);
